// @flow
import React from 'react';
// graphql
import { createFragmentContainer, graphql } from 'react-relay';
// route
import { Link, withRouter } from 'react-router-dom';
// material ui
import IconButton from 'material-ui/IconButton';
import IconRemove from 'material-ui/svg-icons/navigation/close';
// mutation
import * as TopicEditMutation from '../../mutations/TopicEditMutation';
// style
import { colors } from '../../lib/styles';

type Props = {
    topic: Object,
    relay: Object,
};

class TopicsListItem extends React.Component<Props> {
    removeTopic = (value: Object) => (
        <IconButton
            className="topic--remove-btn"
            onClick={() => {
                const sendValues = {
                    ...value,
                };
                sendValues.hidden = true;
                TopicEditMutation.commit(this.props.relay.environment, sendValues, (error) => {
                    const element = document.getElementById(value.id);
                    if (element) {
                        element.classList.add('is-remove');
                        setTimeout(() => {
                            element.remove();
                        }, 500);
                    }
                });
            }}
        >
            <IconRemove color="#777" hoverColor={colors.linkHover} />
        </IconButton>
    );

    renderLink = (name, id) => (
        <Link
            to={`/topic/${id}`}
            className="topic--name"
        >
            {name}
        </Link>
    );

    renderIcons = (seoTitle, seoKeywords, seoDescription) => (
        <div className="topics--icon">
            <div className="topics--icon-item topics--icon-item_seo">
                <span
                    className={seoTitle ?
                        'topic--icon topic--icon-seoTitle is_active' :
                        'topic--icon topic--icon-seoTitle is_disable'
                    }
                />
            </div>
            <div className="topics--icon-item topics--icon-item_seo">
                <span
                    className={seoDescription ?
                        'topic--icon topic--icon-seoDescription is_active' :
                        'topic--icon topic--icon-seoDescription is_disable'
                    }
                />
            </div>
            <div className="topics--icon-item topics--icon-item_seo">
                <span
                    className={seoKeywords ?
                        'topic--icon topic--icon-seoKeywords is_active' :
                        'topic--icon topic--icon-seoKeywords is_disable'
                    }
                />
            </div>
        </div>
    );

    render() {
        const {
            name, id, seoTitle, seoDescription, seoKeywords
        } = this.props.topic;

        return (
            <div className="topics--item" id={id}>
                {this.renderLink(name, id)}
                {this.removeTopic(this.props.topic)}
                {this.renderIcons(seoTitle, seoKeywords, seoDescription)}
            </div>
        );
    }
}

export default withRouter(createFragmentContainer(TopicsListItem, {
    topic: graphql`
        fragment TopicsListItem_topic on Topic {
            id
            name
            slug
            hidden
            seoTitle
            seoDescription
            seoKeywords
        }
    `,
}));



// WEBPACK FOOTER //
// src/components/topics/TopicsListItem.js